import React from "react";
import { Link } from "react-router-dom";
import Icon from "@mdi/react";
import { mdiMapMarker, mdiCheckCircle } from "@mdi/js";
// A school with no logo of its own falls back to the Dance Localé fox icon — the SAME
// asset the backend serves at /events/dl-logo for organisers with no logo, so the
// fallback is identical on event pages and school cards. It is the circular-disc
// variant, which fits the round logo ring; the tall map-pin logo does not.
import danceLocaleLogo from "../assets/dl-logo.png";
import defaultCover from "../assets/instructor_default_cover.jpg";
import { getDanceStyleLabel } from "../config/danceStyles";
import "./SchoolCard.css";

const renderStyleTags = styles => {
    if (!styles || styles.length === 0) return null;
    const visible = styles.slice(0, 3);
    const extra = styles.length - 3;
    return (
        <div className="dl-school-card-styles">
            {visible.map(style => (
                <span key={style} className="dl-school-card-style-tag">
                    {getDanceStyleLabel(style)}
                </span>
            ))}
            {extra > 0 && <span className="dl-school-card-style-tag more">+{extra}</span>}
        </div>
    );
};

const SchoolCard = ({ school, linkTo = false, isPreview = false }) => {
    const rootClass = `dl-school-card${isPreview ? " dl-school-card--preview" : ""}`;

    const inner = (
        <>
            <div
                className="school-card-header"
                style={{ backgroundImage: `url('${school.coverBase64 || defaultCover}')` }}
            >
                <div className="school-card-logo-ring">
                    <img
                        className="school-card-logo"
                        src={school.logoBase64 || danceLocaleLogo}
                        alt={school.name}
                        onError={e => {
                            e.target.src = danceLocaleLogo;
                        }}
                    />
                </div>
                {school.isVerified && (
                    <div className="school-card-verified-badge">
                        <Icon path={mdiCheckCircle} size={0.8} color="white" />
                    </div>
                )}
            </div>
            <div className="school-card-body">
                <h3 className="school-card-name">{school.name}</h3>
                {school.location?.description && (
                    <p className="school-card-location">
                        <Icon path={mdiMapMarker} size={0.65} />
                        {school.location.description}
                    </p>
                )}
                {renderStyleTags(school.styles)}
                {school.description && <p className="school-card-description">{school.description}</p>}
                {school.teachingFormats?.length > 0 && (
                    <div className="school-card-teaching-formats">
                        {school.teachingFormats.map(f => (
                            <span key={f} className="school-card-format-badge">
                                {f}
                            </span>
                        ))}
                    </div>
                )}
            </div>
            <div className="school-card-footer">
                <span className="school-card-link">View School →</span>
            </div>
        </>
    );

    if (linkTo && school.orgSlug) {
        return (
            <Link className={rootClass} to={`/school/${school.orgSlug}`}>
                {inner}
            </Link>
        );
    }

    return <div className={rootClass}>{inner}</div>;
};

export default SchoolCard;
